import { useWorkflow } from "../workflow-context";
import { getAllLinkedDependencies } from "../../utils";

import { SourceType } from "@/components/PowerBlock/Block/SourcesField/SelectSource";

const useSources = (): Record<SourceType, string[]> => {
  const workflow = useWorkflow();
  const { input_variables, activeNode } = workflow;
  const allDependencies = activeNode?.dependencies
    ? getAllLinkedDependencies(workflow.getNodeById.bind(workflow), activeNode.id)
    : [];

  return {
    [SourceType.InputVariable]: input_variables.map(v => v.key),
    [SourceType.Column]: [],
    [SourceType.Dataset]: [],
    [SourceType.Dependency]: allDependencies,
  };
};

export default useSources;
